<template>
  <div class="static-banner">
    <!-- Desktop Hero Banner -->
    <img 
      :src="$t('Header.CarousalImg1')" 
      class="hero-img d-none d-md-block w-100 img-fluid animate-zoom-in" 
      alt="Brand Banner" 
    />
    <!-- Mobile Hero Banner -->
    <img 
      :src="$t('Header.CarousalmobileImg1')" 
      class="hero-img d-md-none w-100 img-fluid animate-zoom-in" 
      alt="Brand Banner" 
    />
  </div>
</template>

<script>
export default {
  name: 'Banner',
};
</script>

<style scoped>
.static-banner {
  position: relative;
  overflow: hidden;
  background-color: #0b1a30;
  width: 100%;
}

.hero-img {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
}

/* Premium zoom micro-animation */
.animate-zoom-in {
  opacity: 0;
  transform: scale(1.04);
  animation: zoomIn 1.2s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
}

@keyframes zoomIn {
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
